<div class="w-9/12 m-auto py-6 min-h-screen flex items-center justify-center">
    <div class=" overflow-hidden pb-8">
        <div class=" text-center">
            <h1 class="text-9xl font-bold text-yellow-600 outline-none">404</h1>
            <h1 class="text-6xl font-medium py-8">oops! Page not found</h1>
            <p class="text-2xl pb-8 px-12 font-medium">
                Oops! The page you are looking for does not exist. It might have
                been moved or deleted.
            </p>
        </div>
    </div>
</div>
